<template>
  <div>
    <div class="profile-page">
      <div v-if="infoText != ''" class="info alert alert-success">
        <p>{{infoText}}</p>
      </div>
      <div v-if="errors.length>0">
        <ul id="errors" class="alert alert-danger">
          <li v-for="error in errors" :key="error">{{error[0]}}</li>
        </ul>
      </div>
      <h1
        style="font-size: 16px;margin: 0px auto;padding: 10px;color: rgb(0, 86, 179);width: 360px;"
      >{{ $t("message.user_profile") }}</h1>
      <div class="form">
        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx PL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
        <template v-if="this.$i18n.locale == 'pl'">
          <img src="../../assets/default-user.png" style="width: 125px;margin: 0px 0px 20px 0px;">

          <input
            v-model="user.name"
            type="text"
            name="name"
            :placeholder="$t('message.name')"
            disabled
          >
          <input
            v-model="user.surname"
            type="text"
            name="surname"
            :placeholder="$t('message.surname')"
            disabled
          >
          <input
            v-model="user.company"
            type="text"
            name="company"
            :placeholder="$t('message.company')"
            disabled
          >
          <input
            v-model="user.city"
            type="text"
            name="city"
            :placeholder="$t('message.city')"
            disabled
          >
          <input
            v-model="user.nip"
            type="text"
            name="nip"
            :placeholder="$t('message.nip')"
            disabled
          >
          <input
            v-model="user.phone"
            type="text"
            name="phone"
            :placeholder="$t('message.phone')"
            disabled
          >
          <input
            v-model="user.email"
            type="text"
            name="email"
            :placeholder="$t('message.email')"
            disabled
          >
          <input
            v-model="user.password"
            type="password"
            name="password"
            :placeholder="$t('message.new_pass')"
          >
          <input
            v-model="user.confirm_password"
            type="password"
            name="confirm_password"
            :placeholder="$t('message.new_pass_repeat')"
          >
          <!-- SERWER -->

          <button @click="saveProfile" style="width:48%; font-size:12px">{{$t('message.actualize')}}</button>
          <router-link to="/" class="btn btn-link">{{$t('message.anuluj')}}</router-link>

          <!-- LOCALHOST TESTOWANIE -->
          <!--
          <div v-if="disabled_pl == true" class="btnDisabled">{{$t('message.register')}}</div>
          <button v-if="disabled_pl == false" @click="save">{{$t('message.register')}}</button>
          -->
        </template>
        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx EN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
        <template v-else>
          <img src="../../assets/logo.png" style="width: 225px;margin: 0px 0px 20px 0px;">

          <input
            v-model="user.name"
            type="text"
            name="name"
            :placeholder="$t('message.name')"
            disabled
          >
          <input
            v-model="user.surname"
            type="text"
            name="surname"
            :placeholder="$t('message.surname')"
            disabled
          >
          <input
            v-model="user.company"
            type="text"
            name="company"
            :placeholder="$t('message.company')"
            disabled
          >
          <input
            v-model="user.country"
            type="text"
            name="country"
            :placeholder="$t('message.country')"
            disabled
          >
          <input
            v-model="user.phone"
            type="text"
            name="phone"
            :placeholder="$t('message.phone')"
            disabled
          >
          <input
            v-model="user.email"
            type="text"
            name="email"
            :placeholder="$t('message.email')"
            disabled
          >
          <input
            v-model="user.password"
            type="password"
            name="password"
            :placeholder="$t('message.new_pass')"
          >
          <input
            v-model="user.confirm_password"
            type="password"
            name="confirm_password"
            :placeholder="$t('message.new_pass_repeat')"
          >
          <p>* - {{$t('message.required')}}</p>

          <!-- SERWER -->

          <button @click="saveProfile" style="width:48%; font-size:12px">{{$t('message.actualize')}}</button>
          <router-link to="/" class="btn btn-link">{{$t('message.anuluj')}}</router-link>

          <!-- LOCALHOST TESTOWANIE -->
          <!--
          <div v-if="disabled_en == true" class="btnDisabled">{{$t('message.register')}}</div>
          <button v-if="disabled_en == false" @click="save">{{$t('message.register')}}</button>
          -->
        </template>
      </div>
      <!--</form>-->
    </div>
  </div>
</template>

<script>
// "
import router from "../../router";
import axios from "axios";

export default {
  name: "Profile",
  data() {
    return {
      userLog: false,
      user: {
        name: "",
        surname: "",
        company: "",
        city: "",
        country: "",
        nip: "",
        phone: "",
        email: "",
        password: "",
        confirm_password: ""
      },
      infoText: "",
      loading: false,
      errored: false,
      visible: true,
      rodo: false,
      errors: []
    };
  },
  components: {},
  computed: {
    names() {
      return states.accounts.map(item => {
        return item.name;
      });
    },
    /*
    users() {
      return this.$store.getters["users/users"];
    },
    */
    disabled_pl() {
      return !this.user.confirm_password == this.user.password;
    },
    disabled_en() {
      return !this.user.confirm_password == this.user.password;
    },
    allCompleted() {
      //return !this.visible;
    }
  },
  methods: {
    // send your recaptcha token to the server to verify it
    submit(response) {
      console.log(response);
    },
    // execute the recaptcha widget
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },

    handleChildrenData(event) {
      console.log("zmienna od child", event);
      //this.visible = event;
    },

    saveProfile: function() {
      //e.preventDefault();
      const self = this;

      let lang = this.$i18n.locale;
      let trans = this.$i18n.messages[lang].message;

      //self.$router.push({ name: "LoginPage" });

      axios
        .post(
          process.env.VUE_APP_ROOT_API + "auth/profile",
          {
            //.post("https://app.pulsar.pl/api/auth/signup", {
            name: this.user.name,
            surname: this.user.surname,
            company: this.user.company,
            city: this.user.city,
            country: this.user.country,
            nip: this.user.nip,
            phone: this.user.phone,
            email: this.user.email,
            password: this.user.password,
            password_confirmation: this.user.confirm_password,
            lang: lang
          },
          { headers: { authorization: "Bearer " + this.userLog.token } }
        )
        .then(function(response) {
          if (response.data.token) {
            console.log("Zmiana hasła w profilu.");
            sessionStorage.setItem("userLog", JSON.stringify(response.data));

            self.errors = [];
            self.infoText = trans["infoTextChangePass"];
            //window.location.replace("/test_login/");
            //self.$router.push({ name: "LoginPage" });
          } else {
            console.log("validacja");
            console.log(response.data);
            /*
            let errors = "";
            for (let err of Object.values(response.data)) {
              errors += err + "\n"; //err trans[err]
            }
            alert(errors);
            */
            self.errors = [];
            for (let err of Object.values(response.data)) {
              //self.errors.push += err + " ";
              self.errors.push(err);
            }
            //alert(self.errors);
            //console.log(self.errors);
          }
        })
        .catch(function(error) {
          console.log(error);
          alert("Problem z połączeniem.");
        });
    }
  },
  beforeCreate() {
    console.log("beforeCreate");
  },
  created() {
    console.log("created");
    let userLogAux = sessionStorage.getItem("userLog");

    if (userLogAux) {
      this.userLog = JSON.parse(userLogAux);

      this.user.name = this.userLog.name;
      this.user.surname = this.userLog.surname;
      this.user.company = this.userLog.company;
      this.user.city = this.userLog.city;
      this.user.country = this.userLog.country;
      this.user.nip = this.userLog.nip;
      this.user.phone = this.userLog.phone;
      this.user.email = this.userLog.email;
      this.user.password = this.userLog.password;
      this.user.password_confirmation = this.userLog.name;
    }
  },
  beforeMount() {
    console.log("beforeMount");
  },
  mounted() {
    console.log("mounted");
  },
  beforeUpdate() {
    console.log("beforeUpdate");
  },
  updated() {
    console.log("updated");
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  destroyed() {
    console.log("destroyed");
  }
};
</script>

<style scoped>
.txtsmall {
  font-size: 14px;
}

/*
#login {
  width: 500px;
  margin: 0 auto;
  padding: 23px;
  background: #ddd;
  border-radius: 10px;
  box-shadow: 5px 5px;
}
*/
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

div.form p {
  font-size: 14px;
  text-align: left;
  color: #999;
}

.info {
  text-align: center;
  font-size: 18px;
  width: 100%;
  margin: 0px auto;
  max-width: 400px;
}

#errors {
  font-size: 14px;
  list-style: disclosure-closed;
  list-style-position: outside;
  list-style-position: outside;
  margin: 0px auto;
  padding: 10px;
  list-style-position: inside;
  width: 360px;
}
#errors li {
  padding: 0px;
}

.btnDisabled {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: no-drop;
}

.login-page {
  width: 360px;
  padding: 0px;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form select {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #0056b3;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #23497f;
  text-decoration: none;
  float: left;
  font-size: 14px;
}
.form .message a:hover {
  color: #0056b3;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before,
.container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #ef3b3a;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/Profile.vue